// import { useQuery } from "@tanstack/react-query";
// import { GetCivilRegistryApi, GetCustomerByCodeApi, GetInfoApi, GetProvincesApi } from "./api.js";
// import { GetCivilRegistryKey, GetCustomerByCodeKey, GetInfoKey, GetInfoSignupKey, GetProvincesKey } from "./key.js";
// export const useGetInfoSignup = () => {
//     return useQuery({
//         queryFn: () => GetInfoApi(),
//         queryKey: GetInfoSignupKey(),
//     });
// };
// // export const useGetInfo = () => {
// //     return useQuery({
// //         queryFn: () => GetInfoApi(),
// //         queryKey: GetInfoKey(),
// //         staleTime: 5 * 60 * 1000,
// //         refetchOnMount: false, // هنگام mount دوباره fetch نکن
// //         refetchOnWindowFocus: false, // هنگام فوکوس پنجره fetch نکن
// //         refetchOnReconnect: false, // هنگام reconnect fetch نکن
// //     });
// // };
// export const useGetCustomerByCode = (customerCode: string | null) => {
//     return useQuery({
//         queryFn: () => GetCustomerByCodeApi(customerCode!),
//         queryKey: GetCustomerByCodeKey(),
//         enabled: !!customerCode, // Only run if customerCode exists
//         retry: false,
//     });
// };
// export const useGetInfo = () => {
//     return useQuery({
//       queryKey: GetInfoKey(),
//       queryFn: () => GetInfoApi(),
//       staleTime: 0,
//       refetchOnMount: 'always',
//       refetchOnWindowFocus: true,
//       refetchOnReconnect: true,
//     });
//   };

// export const useGetProvinces = () => {
//     return useQuery({
//         queryFn: () => GetProvincesApi(),
//         queryKey: GetProvincesKey(),
//         staleTime: 1000 * 60 * 60,
//     });
// };

// export const useGetCivilRegistry = () => {
//     return useQuery({
//         queryFn: () => GetCivilRegistryApi(),
//         queryKey: GetCivilRegistryKey(),
//     });
// };


import { useQuery } from "@tanstack/react-query";
import { GetCivilRegistryApi, GetCustomerByCodeApi, GetInfoApi, GetLegalInfoApi, GetProvincesApi } from "./api.js";
import {
    authKeys,
    GetCivilRegistryKey,
    GetCustomerByCodeKey,
    GetInfoKey,
    GetInfoSignupKey,
    GetLegalInfoKey,
    GetProvincesKey,
} from "./key.js";

export const useGetInfoSignup = () => {
    return useQuery({
        queryFn: () => GetInfoApi(),
        queryKey: GetInfoSignupKey(),
    });
};

export const useGetCustomerByCode = (
    customerCode: string | null,
    options?: { enabled?: boolean }
) => {
    return useQuery({
        queryFn: () => GetCustomerByCodeApi(customerCode!),
        queryKey: ["GetCustomerByCode", customerCode],
        enabled: !!customerCode && (options?.enabled ?? true),
        refetchOnWindowFocus: false,
        staleTime: 0,
        gcTime: 0,
        retry: false,
    });
};

// export const useGetCustomerByCode = (customerCode: string | null) => {
//     return useQuery({
//         queryFn: () => GetCustomerByCodeApi(customerCode!),
//         queryKey: GetCustomerByCodeKey(),
//         enabled: !!customerCode,
//         retry: false,
//     });
// };

// export const useGetInfo = () => {
//     return useQuery({
//         queryKey: GetInfoKey(),
//         queryFn: () => GetInfoApi(),
//         staleTime: 0,
//         refetchOnMount: 'always',
//         refetchOnWindowFocus: true,
//         refetchOnReconnect: true,
//     });
// };

// // ✅ هوک جدید برای کاربر حقوقی
// export const useGetLegalInfo = () => {
//     return useQuery({
//         queryKey: GetLegalInfoKey(),
//         queryFn: () => GetLegalInfoApi(),
//         staleTime: 0,
//         refetchOnMount: 'always',
//         refetchOnWindowFocus: true,
//         refetchOnReconnect: true,
//     });
// };

// core/services/auth/queris.js

export const useGetInfo = (options: { enabled?: boolean } = {}) => {
    return useQuery({
        queryKey: authKeys.userInfo(), // ✅ همه‌ی کش‌های auth رو invalidate می‌کنه
        queryFn: () => GetInfoApi(),
        enabled: options.enabled !== false, // ✅ default true
        refetchOnWindowFocus: true,         // ✅ روی فوکوس پنجره درخواست نزن
        retry: false,
        staleTime: 0,
        // ✅ روی خطا (مثل 401) retry نکن
    });
};

export const useGetLegalInfo = (options: { enabled?: boolean } = {}) => {
    return useQuery({
        queryKey: authKeys.legalInfo(), // ✅ همه‌ی کش‌های auth رو invalidate می‌کنه
        queryFn: () => GetLegalInfoApi(),
        enabled: options.enabled !== false,
        staleTime: 0,
        refetchOnWindowFocus: true,
        retry: false,
    });
};

export const useGetProvinces = () => {
    return useQuery({
        queryFn: () => GetProvincesApi(),
        queryKey: GetProvincesKey(),
        staleTime: 1000 * 60 * 60,
    });
};

export const useGetCivilRegistry = () => {
    return useQuery({
        queryFn: () => GetCivilRegistryApi(),
        queryKey: GetCivilRegistryKey(),
    });
};